<template>
    <div>
        <v-progress-circular :model-value="scorePercentage"
                             :size="50"
                             :width="8"
                             :color="scoreColour"
                             class="score-card">{{ numberWithCommas(score,2) }}</v-progress-circular>
    </div>
</template>
<style>
    .score-card .v-progress-circular__content {
        font-size: 12px!important;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "JobScore",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            score: Number
        },
        methods: {
            numberWithCommas
        },
        computed: {
            scoreColour() {
                if (this.score > 3) {
                    return "green-darken-4";
                } else if (this.score > 2){
                    return "green-darken-2";
                } else if (this.score > 1) {
                    return "green-lighten-1";
                } else if (this.score > 0) {
                    return "green-lighten-4";
                } else if (this.score == 0){
                    return "white";
                } else if (this.score > -1) {
                    return "orange-lighten-1";
                } else if (this.score > -2) {
                    return "red-lighten-2";
                } else {
                    return "red-darken-1";
                }
            },
            scorePercentage() {
                if (this.score > 2) {
                    return 100;
                } else if (this.score > 1) {
                    return 75 + (this.score - 1) * 25;
                } else if (this.score > 0) {
                    return 50 + (this.score - 0) * 25;
                } else if (this.score > -1) {
                    return 25 + (this.score - (-1)) * 25;
                } else {
                    return 0;
                }
            }
        }
    };
</script>